var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPublished = function SvgPublished(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 0.666504C3.89984 0.666504 0.166504 4.39984 0.166504 8.99984C0.166504 13.5998 3.89984 17.3332 8.49984 17.3332C13.0998 17.3332 16.8332 13.5998 16.8332 8.99984C16.8332 4.39984 13.0998 0.666504 8.49984 0.666504ZM8.49984 15.6665C4.82484 15.6665 1.83317 12.6748 1.83317 8.99984C1.83317 5.32484 4.82484 2.33317 8.49984 2.33317C12.1748 2.33317 15.1665 5.32484 15.1665 8.99984C15.1665 12.6748 12.1748 15.6665 8.49984 15.6665ZM11.7332 5.90817L6.83317 10.8082L5.2665 9.2415C4.9415 8.9165 4.4165 8.9165 4.0915 9.2415C3.7665 9.5665 3.7665 10.0915 4.0915 10.4165L6.24984 12.5748C6.57484 12.8998 7.09984 12.8998 7.42484 12.5748L12.9165 7.08317C13.2415 6.75817 13.2415 6.23317 12.9165 5.90817C12.5915 5.58317 12.0582 5.58317 11.7332 5.90817Z",
    fill: "#00B197"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPublished, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/published.55e13eb2.svg";
export { ForwardRef as ReactComponent };